package ru.it_mozaika.sender.js.application

import ru.it_mozaika.sender.js.application.frames.mainFrame
import js.core.jso
import mui.material.styles.ThemeProvider
import react.*
import react.dom.client.createRoot
import react.router.RouterProvider
import react.router.dom.*
import ru.it_mozaika.sender.js.application.context.SubscriptionListProvider
import ru.it_mozaika.sender.js.application.frames.mainPage.MainPage
import ru.it_mozaika.sender.js.application.routes.*
import ru.it_mozaika.sender.js.application.theme.lightTheme

fun main() {
    val container = web.dom.document.getElementById("root") ?: error("Couldn't find root container!")
    moment.updateLocale("ru", jso{
        week = jso{
            dow = 1
        }
    })
    createRoot(container).render(App.create())
}

val browserRouter = createBrowserRouter(
    routes = arrayOf(
        jso{
            id = "root"
            path = "/"
            element = createElement<Props>{
                mainFrame()
            }
            children = arrayOf(
                jso {
                    index = true
                    path = ""
                    element =  SubscriptionListProvider.create {
                        multiple = true
                        MainPage()
                    }
                },
                storeRoutes,
                sendersRoutes,
                quarantineRoutes,
                catalogRoutes,
                subscribersRoutes,
                subscriptionsRoutes,
                propertyRoutes,
                segmentsRoutes,
                campaignsRoutes,
                triggersRoutes,
                templateRoutes,
//                filesRoutes,
                usersRoutes,
//                systemRoutes,
//                apiKeysRoutes,
                s3FileRoute
            )
        },
        editorRoutes
    )
)
val App = FC<Props>{
    ThemeProvider {
        theme = lightTheme
        Layout{
            RouterProvider{
                router = browserRouter
            }
        }
    }
}

